import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import { PlaneRoutePage } from "../app/planeRoute";

export const Route = createFileRoute("/intents")({
  component: IntentsRoute,
});

function IntentsRoute(): JSX.Element {
  const search = Route.useSearch();
  return <PlaneRoutePage kindId="intents" search={search} />;
}
